import AddRoundedIcon from "@mui/icons-material/Add";

import { Fab } from "../Fab";
import { FabContainer } from "./styles";
import { CreateFabProps } from "./types";

export const CreateFab: React.FC<CreateFabProps> = ({ onClick, ariaLabel }) => {
  return (
    <FabContainer>
      <Fab onClick={onClick} aria-label={ariaLabel}>
        <AddRoundedIcon />
      </Fab>
    </FabContainer>
  );
};
